import { useEffect } from 'react';
import type { Cadillac } from '@eti/schema-types';

declare global {
  interface Window {
    _cc?: [string, any][];
  }
}

let shouldAppend = true;

const useCadillac = (data?: Cadillac | null, transactionId?: string | null) => {
  useEffect(() => {
    const script = document.createElement('script');

    if (shouldAppend && data?.filename && data?.siteKey && data?.url && transactionId) {
      window._cc = window._cc || [];
      window._cc.push(['ci', { sid: data.siteKey, tid: transactionId }]);
      window._cc.push(['run', data.url]);

      const params = new URLSearchParams({
        sid: data.siteKey,
        tid: transactionId,
      });

      script.type = 'text/javascript';
      script.async = true;
      script.src = `${data.url}/${data.filename}?${params}`;

      document.body.appendChild(script);
      shouldAppend = false;
    }

    return () => {
      script.remove();
      shouldAppend = true;
    };
  }, [data?.filename, data?.siteKey, data?.url, transactionId]);
};

export default useCadillac;
